
import { CToken } from '../function/axios'

export let cancelSubmitSwitchForm

export default {
  submitForm: (attributes) => {
    return window.ccpAxios.post('/api/switch-request', {
      type: 'switch',
      attributes
    },{
      cancelToken: new CToken(function(c){
        cancelSubmitSwitchForm = c
      })
    })
  }
}
